module.exports = __webpack_public_path__ + "resources/img/img_coolfilter5_m.ad61c1c23356a4422829b7aaea25ce25.png";